export default "__VITE_ASSET__a579aea1__"